import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import RunsheetInvoiceItemsData from './RunSheetInvoiceItems';
import { toast } from 'react-toastify';

interface RunSheetInvoiceItemsProps {
    showItems: boolean;
    items: ItemList[];
    itemTypes: ItemTypeList[];
    gst: number;
    invoiceItemModalType: number; 
    invoiceItem: InvoiceItem;
    showModal: boolean;
    hideModal(): void;
    updateData(invoiceItem: InvoiceItem): void;
    saveModal(): void;
}

interface InvoiceItemsPopup {
    chargeCalloutFee: boolean;
    errors: any;
}

interface InvoiceItem {
    noCalloutInvoiceNotes: string;
    calloutNotes: string;
    invoiceItems: InvoiceItems[];
}

interface InvoiceItems {
    rowIndex: number;
    id: number;
    itemId: number;
    itemTypeId: number;
    scheduleId: number;
    jobQuoteItemId: number;
    rate: number;
    gst: number;
    amount: number;
    description: string;
    active: boolean;
}

interface ItemTypeList {
    id: number;
    name: string;
    chargeGst: boolean;
}

interface ItemList {
    id: number;
    jobQuoteItemId: number;
    name: string;
    chargeGst: boolean;
}

export default class RunsheetInvoiceItemsPopup extends React.Component<RunSheetInvoiceItemsProps, InvoiceItemsPopup> {
    constructor(props: any) {
        super(props);

        this.state = {
            chargeCalloutFee: true,
            errors: {}
        };
    }

    hideModal = () => {
        this.setState({ chargeCalloutFee: true, errors: {} });
        this.props.hideModal();
    }

    deleteError = (errorName: string) => {
        var errorList = this.state.errors;
        delete errorList[errorName];
        this.setState({ errors: errorList });
    }

    update = (invoiceItem: InvoiceItem) => {
        this.props.updateData(invoiceItem);
    }

    updateChargeCalloutFee = (chargeCalloutFee: boolean) => {
        this.setState({ chargeCalloutFee: chargeCalloutFee });
    }

    validate = () => {
        let errors: any = {};
        let formIsValid = true;

        let items = this.props.invoiceItem.invoiceItems;
        var rowNumber = 0;

        var errorString = "Please enter the following values: ";
        var error = false;
        //modal 1 && 4 must have items, modal 2 (callout) may not get charged so no items
        if (this.props.invoiceItemModalType == 1 || this.props.invoiceItemModalType == 4 || (this.props.invoiceItemModalType == 2 && this.state.chargeCalloutFee)) {
            //last row is a blank new row so ignore
            for (var i = 0; i < items.length - 1; i++) {
                rowNumber += 1;
                //ignore any cancelled items and anything that hasn't been changed
                if (items[i].active == true) {
                    var newErrorString = "";
                    if (this.props.showItems) {
                        if (items[i].itemId < 1) {
                            newErrorString += " Item, ";
                            error = true;
                        }
                    }

                    if (items[i].itemTypeId < 1) {
                        newErrorString += " Type, ";
                        error = true;
                    }
                    if (items[i].amount == 0) {
                        newErrorString += " Amount, ";
                        error = true;
                    }
                    if (items[i].description == "") {
                        newErrorString += " Description, ";
                        error = true;
                    }
                    if (newErrorString != "") {
                        errorString += "\n"
                        errorString += "Row " + rowNumber + ": " + newErrorString;
                        errorString = errorString.substring(0, errorString.length - 2);
                    }
                }
            }
            if (error) {
                formIsValid = false;
                errors["invoiceItems"] = errorString;
            }

            var activeItems = items.filter(i => i.active);
            if (activeItems.length - 1 == 0) {
                //make sure there is at least one invoice item (excl the blank row)
                formIsValid = false;
                errors["invoiceItems"] = "At least one invoice item is required";
            }
        }

        //for callout invoices notes are mandatory
        if (this.props.invoiceItemModalType == 2 && !this.props.invoiceItem.calloutNotes) {
            formIsValid = false;
            errors["calloutNotes"] = "Reason for callout is required";
        }

        if (!this.state.chargeCalloutFee && !this.props.invoiceItem.noCalloutInvoiceNotes) {
            formIsValid = false;
            errors["noCalloutInvoiceNotes"] = "Reason why no callout fee charged is required";
        }

        this.setState({ errors: errors });
        return formIsValid;
    }

    save = () => {
        if (this.validate()) {
            this.setState({ errors: {} });
            this.props.saveModal();
        } else {
            toast.error("Fix the validation errors on screen before saving!");
        }
    }

    render() {
        let contents = this.renderDetails();

        return <div>
            {contents}
        </div>;
    }

    renderDetails = () => {
        let items = <RunsheetInvoiceItemsData showItems={this.props.showItems} items={this.props.items} itemTypes={this.props.itemTypes} gst={this.props.gst} invoiceItemModalType={this.props.invoiceItemModalType} invoiceItem={this.props.invoiceItem} chargeCalloutFee={this.state.chargeCalloutFee} errors={this.state.errors} deleteError={this.deleteError} updateData={this.update} updateChargeCalloutFee={this.updateChargeCalloutFee} />
        
        return (
            <Modal size="lg" show={this.props.showModal} onHide={this.hideModal}>
                <Modal.Header className="modal__header--colour">
                    <Modal.Title>Enter {this.props.invoiceItemModalType == 1 || this.props.invoiceItemModalType == 4 ? "extra" : "callout"} invoice items</Modal.Title>
                    <button type="button" className="close" onClick={this.hideModal}>&times;</button>
                </Modal.Header>
                <Modal.Body>
                    {items}
                </Modal.Body>
                <Modal.Footer>
                    <button className="popup-button--yes" onClick={this.save}>Save</button>
                </Modal.Footer>
            </Modal>

        )
    }

}